
import { computed, defineComponent, ref } from 'vue'
import copyToClipboard from 'quasar/src/utils/copy-to-clipboard.js';import useQuasar from 'quasar/src/composables/use-quasar.js';
export default defineComponent({
    name: 'uuid',
    props: {
        id: {
            type: String,
            required: true
        }
    },
    setup (props) {
        const truncatedId = computed(() => props.id.substring(props.id.length - 6))
        const $q = useQuasar()
        const showFull = ref(false)
        const onOpenShowIdDialog = () => { showFull.value = true }
        const handleCopy = () => {
            copyToClipboard(props.id)
            $q.notify({
                color: 'positive',
                message: 'Id copied to clipboard'
            })
            showFull.value = false
        }
        return {
            showFull,
            truncatedId,
            onOpenShowIdDialog,
            handleCopy
        }
    }
})
